import React from "react";
import { useNavigate } from "react-router-dom";
import { Compass, ArrowLeft } from "lucide-react";

const PageNotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-white">
            <div className="absolute -left-[10%] -top-[10%] h-96 w-96 rounded-full bg-blue-50 opacity-60 blur-3xl" />
            <div className="absolute -bottom-[10%] -right-[10%] h-96 w-96 rounded-full bg-orange-50 opacity-60 blur-3xl" />
            <div className="absolute left-20 top-20 h-24 w-24 rotate-45 rounded-lg border-4 border-blue-100" />
            <div className="absolute bottom-24 right-24 h-32 w-32 rounded-full border-4 border-orange-100" />
            <div className="absolute right-1/4 top-1/4 h-12 w-12 rotate-12 border-4 border-blue-100" />
            <div className="absolute bottom-1/3 left-1/4 h-16 w-16 -rotate-12 rounded-lg border-4 border-orange-100" />
            <div className="relative z-10 flex flex-col items-center p-8 text-center">
                <div className="mb-8 flex h-24 w-24 rotate-3 items-center justify-center rounded-2xl bg-blue-50 text-[#7f35b2] shadow-sm">
                    <Compass size={48} className="-rotate-3" />
                </div>

                <h1 className="text-9xl font-extrabold tracking-tight text-[#7f35b2]">
                    4<span className="text-slate-300">0</span>4
                </h1>
                <h2 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    Page not found
                </h2>
                <p className="mt-4 max-w-md text-base text-gray-500">
                    Oops! It looks like you've wandered off the map. The page you're looking for doesn't exist or might have been moved.
                </p>
                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 rounded-lg border-2 border-gray-100 bg-white px-6 py-3 text-sm font-semibold text-gray-700 transition-all hover:border-orange-500 hover:text-orange-600"
                    >
                        <ArrowLeft size={18} />
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;
